module.exports = __webpack_public_path__ + "img/trip.ccfcb549.jpg";